module.exports = __webpack_public_path__ + "img/kaiquicon1.90c2f526.png";